import { Suspense, lazy } from 'react';

import { DataTabTableProps } from './DataTabTable.types';

const DataTabTableContent = lazy(
  () =>
    import(
      /* webpackChunkName: "DataTabTableContent" */
      './DataTabTableContent'
    ),
);

export const DataTabTable = (dataTabTableProps: DataTabTableProps) => {
  return (
    <Suspense fallback={null}>
      <DataTabTableContent {...dataTabTableProps} />
    </Suspense>
  );
};
